import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { Flex } from '../components/common'
import { navHeight } from '../components/Nav'
import MapGL from '../components/MapGL'
import Meta from '../components/Meta'

class MapView extends React.Component {
  state = {
    height: 0
  }

  calculateHeight = () =>
    this.setState({
      height: `calc(${window.innerHeight}px - ${navHeight})`
    })

  componentWillMount () {
    this.calculateHeight()
    window.addEventListener('resize', this.calculateHeight, 100)
    window.addEventListener('resize', this.calculateHeight, 100)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.calculateHeight)
  }

  render () {
    const { locations, tracks } = this.props
    let item = null
    if (window.location.hash) {
      item = locations.find(
        item => item.fields.slug === window.location.hash.slice(1)
      )
    }
    const center = item
      ? [item.fields.coordinates.lon, item.fields.coordinates.lat]
      : null

    return (
      <Flex
        column
        alignStretch
        grow
        style={{
          height: this.state.height
        }}
      >
        <Helmet title='Map of Springbrook National Park' />
        <Meta
          title='Map of Springbrook National Park'
          url='https://discoverspringbrook.com/map'
        />
        <MapGL
          center={center}
          zoom={item ? 14 : null}
          locations={locations}
          tracks={tracks}
          interactive
          controls
          geolocate
        />
      </Flex>
    )
  }
}

MapView.propTypes = {
  locations: PropTypes.array,
  tracks: PropTypes.array
}

export default MapView



// WEBPACK FOOTER //
// ./src/views/MapView.js